import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

interface LanguageToggleProps {
  className?: string;
}

const LanguageToggle: React.FC<LanguageToggleProps> = ({ className = '' }) => {
  const { language, setLanguage } = useLanguage();

  return (
    <div
      role="group"
      aria-label="Language selection"
      className={`flex items-center bg-surface/50 backdrop-blur-md rounded-full p-1 border border-slate-200 dark:border-white/10 shadow-lg ${className}`}
    >
      <button
        onClick={() => setLanguage('en')}
        aria-label="Switch to English"
        aria-pressed={language === 'en'}
        className={`px-4 py-1.5 rounded-full text-xs font-bold transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 ${language === 'en' ? 'bg-primary text-white shadow-md' : 'text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'}`}
      >
        EN
      </button>
      <button
        onClick={() => setLanguage('zh')}
        aria-label="Switch to Chinese"
        aria-pressed={language === 'zh'}
        className={`px-4 py-1.5 rounded-full text-xs font-bold transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 ${language === 'zh' ? 'bg-primary text-white shadow-md' : 'text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'}`}
      >
        中文
      </button>
    </div>
  );
};

export default LanguageToggle;